$(document).on('turbolinks:load', () => {
  if ($(`#nested-${$('.nested').length - 1}`).offset()) {
    $('html, body').animate({
      scrollTop: $(`#nested-${$('.nested').length - 1}`).offset().top,
    }, 'fast');
  }
});
